import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { shortDate } from "@/lib/format";
import { Badge } from "@/components/ui/badge";

const CHANNEL = { whatsapp: "WhatsApp", copia: "testo copiato", email: "email" };

export const ProposalHistory = ({ customerId }) => {
  const { data = [] } = useQuery({ queryKey: ["proposals", customerId], queryFn: async () => (await api.get(`/customers/${customerId}/proposals`)).data });
  if (!data.length) return null;
  return (
    <div className="mt-4 border-t border-border/60 pt-3" data-testid="proposal-history">
      <p className="mb-2 text-[11px] uppercase tracking-widest text-muted-foreground">Capi già proposti</p>
      <div className="space-y-2">
        {data.map((p) => (
          <div key={p.id} className="rounded border border-border/60 p-2 text-xs" data-testid={`proposal-${p.id}`}>
            <p className="text-muted-foreground">{shortDate(p.created_at)} · {p.user_name} · {CHANNEL[p.channel] || p.channel}</p>
            <div className="mt-1 flex flex-wrap gap-1">
              {p.items.map((i) => (
                <Badge key={`${i.name}-${i.size}`} variant="outline" className={`text-[10px] ${i.purchased ? "border-emerald-500/50 text-emerald-400" : ""}`}>
                  {i.name} tg {i.size}{i.purchased ? ` · acquistato${i.order_number ? ` (#${i.order_number})` : ""}` : ""}
                </Badge>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
